export const getInitialVersionValue = (version: string): string => {
  if (!version) return '';
  const [year, month, day] = version.split('-');
  return `${day}.${month}.${year}`;
};
